import { CurrentUserGuard } from 'Src/ng2/routing/guards/current-user-guard/current-user-guard';
import { TogglesGuard } from 'Src/ng2/routing/guards/toggles-guard/toggles-guards';

export const exploreRoute = {
  path: 'explore',
  url: '/explore',
  loadChildren: () => import('../../../../shell/explore/explore.module').then(m => m.ExploreModule),
};
